import PasswordStrength from './password-strength';

export default PasswordStrength;
